<template>
  <div>
    <div
      v-if="allowSendingMessages"
      class="flex flex-row items-center h-16 rounded-md bg-white w-full px-4"
    >
      <div class="flex-grow ml-4">
        <div class="relative w-full">
          <input
            type="text"
            ref="editor"
            placeholder="Type your reply"
            v-model="body"
            class="flex w-full border rounded-md focus:outline-none focus:border-indigo-300 pl-4 h-10 text-sm"
            @keyup.enter="sendMessage"
          />
        </div>
      </div>
      <div class="ml-4">
        <button
          class="flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 rounded-md text-white px-2 py-2 flex-shrink-0"
          @click="sendMessage"
        >
          <span class="ml-1">
            <svg
              class="w-4 h-4 transform rotate-45 -mt-px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
              ></path>
            </svg>
          </span>
        </button>
      </div>
    </div>
    <div v-else>
      <p class="text-sm text-center py-4 bg-white text-gray-700">
        You can't send message to this customer - Time limit exceeded
      </p>
    </div>
  </div>
</template>

<script>
import { differenceInHours } from "date-fns";
export default {
  name: "ChatEditor",
  props: {
    value: {
      type: String
    },
    conversation: {
      type: Object
    }
  },
  data() {
    return {
      body: ""
    };
  },
  computed: {
    allowSendingMessages() {
      const diff = differenceInHours(
        new Date(),
        new Date(this.conversation.lastCustomerReplyTime * 1000)
      );
      return diff < 24;
    }
  },
  mounted() {
    this.setFocusOnEditor();
  },
  methods: {
    sendMessage() {
      this.$emit("enter", this.body);
      this.body = "";
    },
    setFocusOnEditor() {
      if (this.$refs.editor) {
        this.$refs.editor.focus();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
